import { Reducer } from "redux";
import { produce } from "immer";

import { FLOOR_BUILT_ELEMENT_COUNTS_LOADED, FloorBuiltElementCountsLoadedEvent } from "../../../events/loaded/projects/floor_built_element_counts_loaded";

/**
 * Built element counts per floor firebase id. The gateway omits floors with
 * nothing built, so check they loaded before reading a miss as nothing built.
 */
export type FloorBuiltElementCounts = { [floorFirebaseId: string]: number }

export type FloorBuiltElementCountsStore = {
  byFirebaseProjectId: { [projectId: string]: FloorBuiltElementCounts }
}

const reduceFloorBuiltElementCounts: Reducer<FloorBuiltElementCountsStore, FloorBuiltElementCountsLoadedEvent> = (
  builtElementCountsStore: FloorBuiltElementCountsStore = {
    byFirebaseProjectId: {},
  },
  event
) => {
  return produce<FloorBuiltElementCountsStore>(builtElementCountsStore, (draft) => {
    if (!draft.byFirebaseProjectId) {
      draft.byFirebaseProjectId = {};
    }
    switch (event.type) {
      case FLOOR_BUILT_ELEMENT_COUNTS_LOADED: {
        draft.byFirebaseProjectId[event.payload.projectId] = event.payload.builtElementCounts;
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default reduceFloorBuiltElementCounts;
